import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { axiosc } from 'src/app/utils';
import { DrawenLayerGroupDataType, DrawenLayerGroupResultType } from 'src/types/components/draw-module.type';

export const drawenLayerGroupLookup = (tarafId?: number): AxiosPromise<DrawenLayerGroupResultType[]> => {
  return axiosc.get(`${urlsConfig.generics.drawModule.drawenLayerGroups}/list/${tarafId || 0}`, {
    blockSpinner: true,
  });
};

export const drawenLayerGroupSingleLookup = (id: number): AxiosPromise<DrawenLayerGroupResultType> => {
  return axiosc.get(`${urlsConfig.generics.drawModule.drawenLayerGroups}/${id}`, {
    blockSpinner: true,
  });
};

export const drawenLayerGroupCreate = (form: DrawenLayerGroupDataType): AxiosPromise<DrawenLayerGroupResultType> => {
  return axiosc.post(`${urlsConfig.generics.drawModule.drawenLayerGroups}`, form, { blockErrorHandler: true });
};

export const drawenLayerGroupEdit = (form: DrawenLayerGroupDataType): AxiosPromise<DrawenLayerGroupResultType> => {
  return axiosc.patch(urlsConfig.generics.drawModule.drawenLayerGroups, form, { blockErrorHandler: true });
};

export const drawenLayerGroupDelete = (id: number, userTarafId: number): AxiosPromise<any> => {
  return axiosc.delete(`${urlsConfig.generics.drawModule.drawenLayerGroups}/${id}/${userTarafId}`, {
    blockErrorHandler: true,
  });
};

export const drawenLayerGroupCopy = (
  id: number,
  name: string,
  tarafId: number,
): AxiosPromise<DrawenLayerGroupResultType> => {
  return axiosc.post(
    `${urlsConfig.generics.drawModule.drawenLayerGroups}/copy/${id}`,
    { name, tarafId },
    { blockErrorHandler: true },
  );
};

export const getAllLayers = () => {
  return axiosc.get(`${urlsConfig.generics.drawModule.drawenLayerGroups}/all`, {
    blockSpinner: true,
  });
};
